// Erişim çekmecesi — kırılım gizleme onay satırları (spec §6.5 DR10, §8 K3; mockup Portal.dc.html alt
// bant). Bir alt kalem (istisnayla ya da grup seviyesiyle) gizlenip diğerleri görünür kalınca toplam
// başına amber satır: "<toplam> › <gizlenen>: Toplam gizlenecek; …" + toplamı kullanan hesaplanan
// göstergeler + [Diğer kalemleri de gizle] (tüm gruplardaki görünür üyeler aynı kayıtta gizlenir) /
// [Yalnız bu kalemi gizle] (onay — aynı gizleme kümesinde düğmeler tekrar sorulmaz). Engel değil:
// kayıt her durumda yapılabilir. Portal ve danışman çekmecesi aynı bileşen (AccessSetEditor).

import { useState } from "react";
import type { ClientAdminSet } from "@mahir/shared";
import { CLIENT_ADMIN_COPY } from "../../lib/client-admin-copy";
import { breakdownHideWarnings, hideOtherMembers } from "../../lib/client-access-breakdown";
import type { SetDraftV2 } from "../../lib/client-access-draft-v2";

const C = CLIENT_ADMIN_COPY.drawer;

const band: React.CSSProperties = {
  background: "var(--color-warning-bg)",
  color: "var(--color-warning-text)",
  border: "1px solid var(--color-warning-border)",
};

const btn: React.CSSProperties = {
  minHeight: 44,
  padding: "0 12px",
  borderRadius: 8,
  border: "1px solid var(--color-warning-border)",
  background: "var(--color-surface)",
  color: "var(--color-text)",
  fontWeight: 600,
};

interface Props {
  set: ClientAdminSet;
  draft: SetDraftV2;
  disabled: boolean;
  onChange: (next: SetDraftV2) => void;
}

export function AccessBreakdownWarnings({
  set,
  draft,
  disabled,
  onChange,
}: Props): JSX.Element | null {
  const [confirmed, setConfirmed] = useState<ReadonlySet<string>>(new Set());
  const warnings = breakdownHideWarnings(set, draft);
  // TODO-KPI-119: canlı bölge HEP DOM'da (uyarı sonradan eklenince ekran okuyucu duyurur)
  if (warnings.length === 0)
    return <div aria-live="polite" data-testid="access-breakdown-warnings" />;
  return (
    <div className="flex flex-col gap-2" aria-live="polite" data-testid="access-breakdown-warnings">
      {warnings.map((w) => (
        <div
          key={w.totalId}
          role="note"
          aria-label={C.breakdownHideAria(w.totalLabel)}
          data-testid="access-breakdown-warning"
          className="rounded-md px-3 py-2 text-xs"
          style={band}
        >
          <p>
            <b>{C.breakdownHideLead(w.totalLabel, w.hiddenLabels)}:</b> {C.breakdownHideWarning}
          </p>
          {w.dependents.length > 0 ? (
            <p className="mt-1" data-testid="access-breakdown-dependents">
              {C.dependents(w.dependents)}
            </p>
          ) : null}
          {confirmed.has(w.key) ? null : (
            <div className="flex flex-wrap gap-2 mt-2">
              <button
                type="button"
                style={btn}
                disabled={disabled}
                onClick={() => onChange(hideOtherMembers(set, draft, w.totalId))}
              >
                {C.hideOthers}
              </button>
              <button
                type="button"
                style={btn}
                disabled={disabled}
                onClick={() => setConfirmed((prev) => new Set(prev).add(w.key))}
              >
                {C.hideOnlyThis}
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
